import { cn } from "@/lib/cn";

const SIZE_CLASSES = {
  sm: "h-3.5 w-auto",
  md: "h-5 w-auto",
  lg: "h-7 w-auto",
} as const;

export function Wordmark({ size = "md", className }: { size?: keyof typeof SIZE_CLASSES; className?: string }) {
  return (
    <img
      className={cn("shrink-0 bg-transparent object-contain", SIZE_CLASSES[size], className)}
      src="/brand/studside-wordmark.png"
      alt="Studside"
      width={1420}
      height={395}
      draggable={false}
    />
  );
}
